import React from 'react';
import LightSpeed from 'react-reveal/LightSpeed';
import Zoom from 'react-reveal/Zoom';
import SectionTitle from '../../../SectionTitle.style';
import { useMobile, useMobileLandscape } from '../../queries';
import MyParticles from '../MyParticles';
import * as S from './AboutUs.style';

function AboutUs() {
  const isMobile = useMobile();
  const isMobileLandscape = useMobileLandscape();
  return (
    <S.Container>
      <SectionTitle style={{ paddingTop: '4rem' }}>about us</SectionTitle>
      <S.Title>
        <h3> Shapira Bros is New York-based Production Company. </h3>
        <h3 style={{ paddingBottom: '20px' }}>We create high-quality content for TV and social media with the lead focus on commercials, music videos, and fashion. </h3>
      </S.Title>
      <S.ImageWrapper>
        <Zoom bottom>
          <img alt="Shapira Brothers" src="../img/about1.jpg" />
        </Zoom>
      </S.ImageWrapper>

      <S.BioWrapper>

        <S.DescriptionTextWrapper>
          <LightSpeed left>
            <h2 style={{ color: 'wheat', letterSpacing: '2px' }}> DON SHAPIRA </h2>
            <p>
                Don is a highly creative person.
              {' '}
              <br />
                If you would know Don when he was younger you would remember all
                of the great ideas he had for the entertainment industry,
                only back then he would use his friends and family to make his vision come true.
                Don moved to New York soon after he finished his military service to fulfill his
                dream of becoming a successful director, and what better place to do it than the
                big city. Since Don moved to New York he successfully directed and produced
                commercials for various brands including Google, Amazon, and Oppo.

            </p>
          </LightSpeed>

        </S.DescriptionTextWrapper>
        <S.DescriptionTextWrapper>
          <LightSpeed right>
            <h2 style={{ color: 'wheat', letterSpacing: '2px' }}> KIM SHAPIRA </h2>
            <p>
                Since Kim was young he had a sense of putting things together, it
                started with broken stuff he would fix and rebuild, and later
                on to small weekly events he would do in his house while putting
                together different people who were strangers to each other and
                became close friends through those events. During Kim's military
                service he had the opportunity to become an officer, however, Kim
                abandoned the opportunity and moved to New York to his older
                brother. Today Kim is a successful producer managing Shapira Bros
                together with his brother Don.
            </p>
          </LightSpeed>
        </S.DescriptionTextWrapper>
      </S.BioWrapper>

      {/*      <S.DescriptionWrapper paddingTop="15px" mobileOrder={-1}> */}
      {/*        <LightSpeed right> */}

      {/*          <img */}
      {/*            src="../img/about2.jpg" */}
      {/*          /> */}
      {/*        </LightSpeed> */}
      {/*      </S.DescriptionWrapper> */}
      <h2 style={{
        maxWidth: '800px', textAlign: 'center', margin: '20px auto', padding: '20px 0', borderTop: '1px solid gray', borderBottom: '1px solid gray',
      }}
      >
        {' '}
       With Don's highly creative mind and Kim's managing skills,
          there is no goal out of reach, there is no limit for
          what they can do, and there is no better match for a winning production.
      </h2>
      {/*      <StyledReactPlayerWrapper> */}
      {/*        <ReactPlayer */}
      {/*          className="react-player" */}
      {/*          url="https://www.youtube.com/watch?v=cBIg3ZbVH58&" */}
      {/*          width="100%" */}
      {/*          height="100%" */}
      {/*          controls */}
      {/*        /> */}
      {/*      </StyledReactPlayerWrapper> */}
      {!isMobile && !isMobileLandscape && <MyParticles />}
    </S.Container>
  );
}

export default AboutUs;
